import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Alert, AlertTitle } from '@mui/material';

import { useTranslation } from 'react-i18next';
import getErrorMessage from '../../../../../shared/api/getErrorMessage';
import getErrorCode from '../../../../../shared/api/getErrorCode';
import ERROR_CODES from '../../../../../shared/api/ERROR_CODES';

function ResultAlert({ isError, isSuccess, errorData }) {
  const { t, i18n } = useTranslation('translation');

  const getErrorTextFromCodeRequest = useCallback(
    (error) => {
      if (!error) return null;
      switch (error.status) {
        case 400:
          return getErrorMessage(getErrorCode(error.status, error), error);
        case 403:
          return getErrorMessage(ERROR_CODES.FORBIDDEN, error);
        case 404:
          return getErrorMessage(ERROR_CODES.COMPANY_FOR_LOGISTIC_NOT_FOUND, error);
        default:
          return getErrorMessage(ERROR_CODES.UNKNOWN_ERROR, error);
      }
    },
    [i18n?.language],
  );

  if (isError) {
    return (
      <Alert sx={{ width: '100%' }} severity="error">
        <AlertTitle>{t('error')}</AlertTitle>
        {getErrorTextFromCodeRequest(errorData)}
      </Alert>
    );
  }

  if (isSuccess) {
    return (
      <Alert sx={{ width: '100%' }} severity="success">
        <AlertTitle>Успешно</AlertTitle>
        Данные успешно сохранены
      </Alert>
    );
  }

  return null;
}

ResultAlert.propTypes = {
  isError: PropTypes.bool,
  isSuccess: PropTypes.bool,
  errorData: PropTypes.shape(),
};

ResultAlert.defaultProps = {
  isError: false,
  isSuccess: false,
  errorData: null,
};

export default ResultAlert;
